export const APP_ID = "Reactweb";

export enum EHttpMethods {
  Get = "GET",
  Delete = "DELETE",
  Patch = "PATCH",
  Post = "POST",
  Put = "PUT",
}